/** Returns true when the MFA/auth token lifetime has elapsed. */
export function isAuthTokenExpired(expiresAt: string | Date | null | undefined): boolean {
  if (!expiresAt) {
    return false;
  }
  const expiryMs =
    typeof expiresAt === 'string' ? Date.parse(expiresAt) : expiresAt.getTime();
  if (Number.isNaN(expiryMs)) {
    return false;
  }
  return Date.now() >= expiryMs;
}
